<template>
    <div class="w-100">
        <div class="artist-card-info">
            <div class="artist-count">
                {{ artistCount }} Offer{{ artistCount > 1 ? 's' : '' }} to Review
            </div>
        </div>
        <div class="budget-to-rewiev">
            <div
                class="d-flex offers-to-reviews-container"
                v-for="(artist, index) in getOfferToReviewArtist"
                :key="index"
                @click="(event) => goToArtist(event, artist.slug)"
                role="button"
            >
                <div class="position-relative">
                    <a :href="'/artists/' + artist.slug" target="_blank">
                        <img :src="artist.profile_picture" alt="artist-img" class="user-img" />
                    </a>
                    <div class="player" v-if="artist.sample">
                        <div class="js-audios-container" @mouseenter="onAudioEnter">
                            <div
                                class="artist-audio custom-audio-element d-flex align-items-center justify-content-evenly"
                                :data-audio-idx="artist.sample.id"
                            >
                                <audio
                                    hidden
                                    class="d-none"
                                    :data-audio-idx="artist.sample.id"
                                >
                                    <source :src="artist.sample.url" type="audio/mp3" />
                                </audio>
                                <div class="position-relative">
                                    <button
                                        ref="play"
                                        class="btn btn-without-focus btn-profile-sound js-profile-btn btn-profile-sound-play play js-play-audio"
                                    ></button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <p class="song-name">
                                {{ artist.sample.title }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="artist-container">
                    <div class="d-flex justify-content-between align-items-center">
                        <a
                            class="artist-name"
                            :href="'/artists/' + artist.slug"
                            target="_blank"
                        >
                            {{ artist.artist_name }}
                        </a>
                        <div class="d-flex align-center">
                            <img
                                :src="getIcon + 'Star1.png'"
                                alt="rating"
                                class="social-img mx-1"
                            />
                            <span class="rating-count">{{ artist.rating }}</span>
                        </div>
                    </div>
                    <p class="social-reach-card" v-if="!!artist.social_reach">
                        {{ formatSummedValue(artist.social_reach) }} Followers
                    </p>
                    <div class="atrist-locat">{{ artist.location }}</div>
                    <div class="tag-input" v-if="artist.keywords">
                        <div
                            class="artist-tag"
                            v-for="(genre, index) in artist.keywords.split(',')"
                            :key="index"
                        >
                            {{ genre }}
                        </div>
                    </div>
                    <hr style="background: #8b8b8b" />
                    <p
                        class="per-set-price"
                        :style="{ color: !artist.counter_pending ? '#8b8b8b' : '#c9cd00' }"
                    >
                        ${{ venuePays(artist) }} / {{ setDuration(artist) }} Set
                    </p>
                    <div class="decline-btn">
                        <button
                            class="offer-rewiev"
                            :class="{ 'counter-pending': !artist.counter_pending }"
                            :disabled="!artist.counter_pending"
                            @click="showOfferReview(artist.bid_artist_id)"
                        >
                            <span>{{
                                artist.counter_pending ? 'Review Offer' : 'Counter Pending'
                            }}</span>
                        </button>
                        <button class="btn-underline">
                            <span class="btn-decorate" v-b-modal.modal-decline-artist
                                >Decline</span
                            >
                        </button>
                        <b-modal
                            no-enforce-focus
                            centered
                            hide-header
                            hide-footer
                            id="modal-decline-artist"
                            content-class="modal-decline-artist"
                            size="xl"
                        >
                            <p class="modal-title-text">
                                You are about to decline this offer?
                            </p>
                            <p class="modal-warning-text">
                                Are you sure you want to turn this down?
                            </p>
                            <div class="d-flex flex-column align-items-center">
                                <button
                                    class="return-btn"
                                    @click="$bvModal.hide('modal-decline-artist')"
                                >
                                    Return
                                </button>
                                <p
                                    class="cancel-btn"
                                    @click="declineArtist(artist.bid_artist_id)"
                                    slot="modal-footer"
                                >
                                    Decline
                                </p>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
            <div class="book-more-artist-card">
                <p class="book-artist-title">Need more offers?</p>
                <div class="action-items">
                    <button @click="$emit('open-invite')" class="book-artist-btn">
                        Invite More Artists
                    </button>
                    <button @click="copyUrl" class="copy-link-btn">
                        <img
                            class="copy-link-img"
                            src="/images/icons/copy-url-2.svg"
                            alt="copy-icon"
                        />
                        <span class="copy-link-text">Copy Link</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="bottom-line-up-flow"></div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { notification } from '../../../../helpers/notification'
    export default {
        name: 'OffersToReviews',
        props: {
            eventId: {
                type: Number
            },
            artistInfo: {
                type: Object
            }
        },
        emits: ['update:declineInfo', 'update:offerMode', 'update:bidArtist', 'open-invite'],
        data: () => ({
            artists: [],
            offerMode: ''
        }),
        computed: {
            artistCount() {
                return this.artists.length
            },
            getIcon() {
                return '/images/'
            },
            venuePays() {
                return (artist) => {
                    const venuePays =
                        parseFloat(artist.propose.payout) +
                        parseFloat(artist.propose.payout) * parseFloat(artist.venue_fee)
                    return parseFloat(venuePays).toFixed(2)
                }
            },
            getOfferToReviewArtist() {
                return this.artists
            },
            setDuration() {
                return (artist) => {
                    const duration = Math.ceil(
                        parseFloat(artist.propose.duration) * 60
                    ).toFixed(0)
                    return `${duration} mins`
                }
            }
        },
        methods: {
            goToArtist(event, slug) {
                const targetElement = this.$refs.play

                if (targetElement && targetElement.contains(event.target)) {
                    return
                } else if (!slug) return

                window.open('/artists/' + slug, '_blank')
            },
            formatSummedValue(num) {
                return new Intl.NumberFormat('en', {
                    notation: 'compact'
                }).format(num)
            },
            async getOffersTOtoReviewCard() {
                try {
                    const response = await axios.get(
                        '/api/events/manage/' + this.eventId + '/artists-review-cards'
                    )
                    this.artists = response.data.data
                } catch (error) {
                    notification('error', error)
                }
            },
            async declineArtist(bid_artist_id) {
                try {
                    const response = await axios.put(
                        '/api/event/manage/' + bid_artist_id + '/decline'
                    )
                    this.$bvModal.hide('modal-decline-artist')
                    notification(
                        'success',
                        'Artist request to event was declined successfully'
                    )
                    window.location.reload()
                    const declineInfo = response.data.artist.artist_info
                    this.$emit('update:declineInfo', declineInfo)
                } catch (error) {
                    notification('error', error)
                }
            },
            onAudioEnter() {
                window.__initAudioElements()
                window.__pauseOtherAudios()
            },
            showOfferReview(id) {
                this.bidArtist = id
                this.offerMode = 'showOffer'
                this.$emit('update:offerMode', this.offerMode)
                this.$emit('update:bidArtist', this.bidArtist)
            },
            copyUrl() {
                const domainName = window.location.origin
                const urlToCopy = domainName + '/opportunities/?opportunity=' + this.eventId
                const tempInput = document.createElement('input')
                tempInput.value = urlToCopy
                document.body.appendChild(tempInput)
                tempInput.select()
                document.execCommand('copy')
                document.body.removeChild(tempInput)
            }
        },
        async created() {
            await this.getOffersTOtoReviewCard()
        }
    }
</script>

<style>
    .modal-decline-artist {
        display: inline-flex;
        padding: 48px 80px;
        justify-content: center;
        border-radius: 20px;
        background: #161616;
    }
    @media (max-width: 600px) {
        .modal-decline-artist {
            padding: 20px;
            margin: 0 10px;
        }
    }
</style>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .book-more-artist-card {
        width: 336px;
        height: 513px;
        padding: 24px;
        border-radius: 15px;
        background: #262626;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        margin: 20px 0;
    }
    .action-items {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 5px;
        width: 100%;
    }
    .book-artist-title {
        color: #c9cd00;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .book-artist-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px 32px;
        border-radius: 120px;
        background: #c9cd00;
        width: 100%;
        border: none;
        color: #000;
        @include base-font-18;
        line-height: 133%;
    }
    .copy-link-btn {
        display: flex;
        padding: 12px 20px;
        justify-content: center;
        align-items: center;
        align-self: stretch;
        border-radius: 120px;
        border: 1px solid $lime-2;
        background: transparent;

        .copy-link-img {
            width: 24px;
            height: 24px;
            margin-right: 8px;
        }
    }
    .copy-link-text {
        color: $lime-2;
        @include base-font-18;
        line-height: 133%;
    }
    .counter-pending {
        border: 1px solid #8b8b8b !important;
        color: #8b8b8b !important;
    }
    .counter-pending:hover {
        background: #c9cd00 !important;
        color: #000 !important;
    }
    .cancel-btn {
        color: #8b8b8b;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        text-decoration-line: underline;
        cursor: pointer;
    }
    .modal-warning-text {
        color: #acacac;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        text-align: center;
    }
    .return-btn {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        border: 0;
        max-width: 120px;
        max-height: 90px;
        margin-bottom: 24px;
        margin-top: 40px;
    }
    .modal-title-text {
        color: #f5f5f5;
        font-feature-settings: 'dlig' on, 'ss05' on, 'ss10' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
        text-align: center;
    }
    .song-name {
        color: #f5f5f5;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .bottom-line-up-flow {
        display: flex;
        flex-direction: row;
        border: 1px solid #646464;
        width: 90%;
        margin: 25px 60px 60px 60px;
    }
    .artist-count {
        color: #c9cd00;
        font-size: 44px;
        font-family: 'Instrument Sans';
        font-weight: 500;
        line-height: 110%;
        display: flex;
        align-items: center;
    }
    .decline-btn {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
    }
    .user-img {
        border-radius: 15px 15px 0 0;
        height: 250px;
        width: 100%;
        object-fit: cover;
    }
    .btn-decorate {
        text-decoration: underline;
        color: #646464;
        text-align: center;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.16px;
    }
    .offer-rewiev {
        display: flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        border: 1px solid#c9cd00;
        background: #262626;
        color: #c9cd00;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        max-width: 336px;
    }
    .offer-rewiev:hover {
        background: #c9cd00;
        color: #000;
    }
    .btn-underline {
        color: #646464;
        text-align: right;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        text-decoration-line: underline;
        border: none;
        background: none;
        margin-top: 25px;
        padding-bottom: 38px;
    }
    .per-set-price {
        font-size: 22px;
        font-family: 'Instrument Sans';
        font-weight: 500;
        line-height: 120%;
        margin: 0;
        letter-spacing: -0.22px;
    }
    .artist-tag {
        display: flex;
        max-width: 300px;
        padding: 3px 10px 4px 10px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        border: 1px solid #8b8b8b;
        color: #8b8b8b;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .tag-input {
        display: flex;
        align-items: flex-start;
        overflow: auto;
        gap: 4px;
    }
    .tag-input::-webkit-scrollbar {
        display: none;
    }
    .atrist-locat {
        color: #646464;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.14px;
        margin: 0px 0px 10px 0px;
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .social-reach-card {
        color: #acacac;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.16px;
        margin-bottom: 0px;
    }
    .social-img {
        max-height: 18px;
        max-width: 18px;
    }
    .rating-count {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .budget-to-rewiev {
        display: flex;
        flex-wrap: wrap;
        margin: 0 50px;
        gap: 20px;
    }
    .btn-profile-sound-play {
        background-image: url(/images/play-button-event.png);
    }
    .offers-to-reviews-container {
        flex-direction: column;
        margin: 20px 0;
        border-radius: 15px;
        background: #262626;
        max-width: 336px;
        width: 100%;
        max-height: 513px;
        height: 100%;
    }
    .artist-container {
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .artist-name {
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 75%;
        color: #acacac;
        font-size: 26px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
        margin-bottom: 5px;
        cursor: pointer;
        text-decoration: none;
    }
    .artist-card-info {
        margin: 0 50px;
    }
    .player {
        bottom: 20px;
        display: flex;
        gap: 10px;
        width: -webkit-fill-available;
        left: 15%;
        position: absolute;
        left: 0%;
        justify-content: center;
        align-items: center;
    }
    @media (max-width: 600px) {
        .budget-to-rewiev {
            margin: 0;
            justify-content: center;
        }
        .offers-to-reviews-container {
            flex: 0 1 100%;
            margin: 16px;
        }
        .artist-card-info {
            margin: 0 16px;
        }
        .artist-count {
            font-size: 38px;
        }
        .bottom-line-up-flow {
            margin: 40px 16px;
        }
    }
</style>
